<template>
  <a-icon :component="component"></a-icon>
</template>

<script>
export default {
  name: 'ServiceIcon',
  data () {
    return {
      component: {
        template: `
          <svg viewBox="0 0 1028 1024" width="1em" height="1em">
            <path d="M146.285714 0h731.428572c80.457143 0 146.285714 65.828571 146.285714 146.285714v731.428572c0 80.457143-65.828571 146.285714-146.285714 146.285714H146.285714c-80.457143 0-146.285714-65.828571-146.285714-146.285714V146.285714C0 65.828571 65.828571 0 146.285714 0z" fill="currentColor" p-id="74285"></path>
            <path d="M804.571429 365.714286v-36.571429c0-21.942857-14.628571-36.571429-36.571429-36.571428H555.885714v-36.571429c0-21.942857-14.628571-36.571429-29.257143-36.571429H256c-21.942857 0-36.571429 14.628571-36.571429 36.571429V365.714286h585.142858zM219.428571 438.857143v321.828571c0 29.257143 87.771429 43.885714 109.714286 43.885715h365.714286c21.942857 0 109.714286-14.628571 109.714286-43.885715V438.857143H219.428571z" fill="#FFFFFF" p-id="74286"></path>
          </svg>
        `
      }
    }
  }
}
</script>
